import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './config/api' // fetch interceptor — deve ser importado antes de qualquer componente
import App from './App'
import './index.css'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
